import React from "react";
import { RLayerTileWebGL, RLayerVector, RStyle } from "rlayers";
import { GeoJSON } from "ol/format";

function RenderLayout(RouterData) {
  const { itinerari } = RouterData.route.params;

  let items = [];
  let index = 0;
  for (let layout of itinerari.mapes.layouts) {
    if (layout.tipus == "mapa") {
      items.push(
        <RLayerTileWebGL
          key={index++}
          url={layout.url}
          properties={{ label: "IternaturaStyle" }}
        />,
      );
    } else if (layout.tipus == "track") {
      items.push(
        <RLayerVector
          features={new GeoJSON({
            featureProjection: "EPSG:3857",
          }).readFeatures(geojsonFeatures)}
          key={index++}
        >
          <RStyle.RStyle>
            <RStyle.RStroke color={itinerari.color_itinerari} width={3} />
            <RStyle.RFill color="transparent" />
          </RStyle.RStyle>
        </RLayerVector>,
      );
    }
  }
  return items;
}

export default RenderLayout;
